import SectionText from './SectionText'

export default SectionText
